import Vue from 'vue'
import Vuex from 'vuex'
import VueMarkdown from 'vue-markdown';

Vue.component('vue-markdown', VueMarkdown);
Vue.use(VueMarkdown);

Vue.use(Vuex)

export default new Vuex.Store({
   state: {

     jsonData:[]

  },
  getters:{
    getKirbyData: (state) => {
        return state.jsonData
      }
  },
  mutations: {

    setJsonData (state, value) {
      state.jsonData=value
    },

    initialiseStore(state) {
      // test for local store
      if(localStorage.getItem('store_memoria_pwa')) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store_memoria_pwa')))
        );
      }
    }

  }
})





// WEBPACK FOOTER //
// ./src/store/index.js